import { NotificationByUserModel } from '../../models/notification_event/notification-by-user.model';
import { inject, Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { NotificationEventAction } from './notification-event.action';
import { finalize, from, Observable, timer } from 'rxjs';
import { NotificationEventRequestService } from '../../services/request/notification-event-request.service';
import { combineLatestWith, map } from 'rxjs/operators';
import { PagedNotificationEventModel } from '../../models/notification_event/paged-notification-event.model';

interface NotificationEventXsStateModel {
  notificationEvents: NotificationByUserModel[];
  unprocessedCount: number;
  requestInProgress: boolean;
}


const getDefaults = (): NotificationEventXsStateModel => ({
  notificationEvents: [],
  unprocessedCount: 0,
  requestInProgress: false,
});

@State<NotificationEventXsStateModel>({
  name: 'notificationEventState',
  defaults: getDefaults()
})
@Injectable()
export class NotificationEventXsState {

  private notificationEventRequestService: NotificationEventRequestService = inject(NotificationEventRequestService);

  private readonly REQUEST_DELAY: number = 500;
  private PAGE_SIZE = 5;

  @Selector()
  static notificationEvents(state: NotificationEventXsStateModel): NotificationByUserModel[] {
    return state.notificationEvents;
  }

  @Selector()
  static unprocessedCount(state: NotificationEventXsStateModel): number {
    return state.unprocessedCount;
  }

  @Selector()
  static requestInProgress(state: NotificationEventXsStateModel): boolean {
    return state.requestInProgress;
  }

  @Action(NotificationEventAction.ReloadNotifications)
  public reloadNotifications(
    ctx: StateContext<NotificationEventXsStateModel>,
    action: NotificationEventAction.ReloadNotifications
  ): Observable<void> {
    if (action.userId == null) {
      throw new Error('user id can not be null');
    }

    ctx.patchState({
      ...getDefaults(),
      requestInProgress: true
    });

    return from(this.notificationEventRequestService.fetchPageByUserId(action.userId, 0, this.PAGE_SIZE))
      .pipe(
        combineLatestWith(
          this.notificationEventRequestService.fetchAllUnprocessed(action.userId),
          timer(this.REQUEST_DELAY)
        ),
        map(([notificationEvents, unprocessedNotifications, _]
             : [PagedNotificationEventModel, NotificationByUserModel[], any]): void => {
          ctx.patchState({
            notificationEvents: notificationEvents.values,
            unprocessedCount: unprocessedNotifications.length
          });
        }),
        finalize(() => ctx.patchState({requestInProgress: false}))
      );
  }
}
